module.exports = __webpack_public_path__ + "static/communify-73a5cecc07e904d87bf90524869d1fad.jpg";